import React from "react";
// import placeholder from "../assets/Car place holder PNG.png";

const TwoCars = ({ heroSectionData }) => {
  return (
    <>
      <section className="py-16 ">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {heroSectionData.map((heroSection, index) => (
              <div
                key={index}
                className="auction-card relative rounded-xl overflow-hidden h-[370px]"
              >
                {/* Background Image */}
                <div
                  className="absolute inset-0 w-full h-full"
                  style={{
                    backgroundImage: `url(${heroSection?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />

                {/* Content Overlay */}
                <div className="relative z-10 h-full  md:p-8 flex items-center">
                  <div className="  p-10 text-white">
                    <h3 className="text-[24px] md:text-[22px] lg:text-[32px] font-bold mb-4">
                      {heroSection.title}
                    </h3>
                    {/* <p className='text-[16px] font-normal mb-6'>
                    dangerouslySetInnerHTML={{
                      __html: heroSection?.description,
                    }}
                    </p> */}

                    <div
                      className=" mb-6 "
                      dangerouslySetInnerHTML={{
                        __html: heroSection?.description,
                      }}
                    />
                    <button className="px-4 py-3 md:px-5 md:py-3 flex items-center gap-2 bg-white text-black rounded-xl text-[13px] md:text-[11px] lg:text-[17.89px] font-medium hover:bg-primary-dark hover:text-white">
                      {heroSection.buttonText.toUpperCase()}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                      >
                        <path
                          d="M16.4315 0.529297H6.22589C5.96947 0.529297 5.76199 0.736786 5.76199 0.9932C5.76199 1.24961 5.96947 1.4571 6.22589 1.4571H15.3116L0.331228 16.4375C0.150007 16.6187 0.150007 16.9122 0.331228 17.0934C0.421817 17.184 0.540544 17.2293 0.659227 17.2293C0.77791 17.2293 0.896594 17.184 0.987226 17.0934L15.9676 2.11305V11.1988C15.9676 11.4552 16.175 11.6627 16.4315 11.6627C16.6879 11.6627 16.8954 11.4552 16.8954 11.1988V0.9932C16.8954 0.736786 16.6878 0.529297 16.4315 0.529297Z"
                          fill="#050B20"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TwoCars;
